// Shared gold treatments. Change here to restyle every gold button and accent at once.
export const GOLD_GRADIENT = 'linear-gradient(180deg, #f6e7b4 0%, #d9b357 42%, #b98d2e 58%, #e8cc7a 100%)';

export const goldButton = {
  background: GOLD_GRADIENT,
  color: '#1a1a1a',
  border: '1px solid #b8903a',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.7), 0 2px 6px rgba(140,109,31,0.35)',
  textShadow: '0 1px 0 rgba(255,255,255,0.35)',
};
